import type { ReactNode } from 'react';
import './ui.css';

export type PillVariant = 'ok' | 'warn' | 'err' | 'neutral';

export function StatusPill({ variant, children }: { variant: PillVariant; children: ReactNode }) {
  return (
    <span className={`pill pill-${variant}`}>
      <span className="pill-dot" aria-hidden="true" />
      {children}
    </span>
  );
}
